import { UPDATE_PRIVACY_SETTINGS } from "../Actions/Constants";

const initialState = {
  hideProfile: 0,
  seenReceipt: 0
};

export const PrivacySettingsReducer = (state = initialState, action = {}) => {
  if (action.type === UPDATE_PRIVACY_SETTINGS) {
    return {
      ...state,
      ...action.payload
    };
  }

  return state;
};